import clsx from "clsx";
import React from "react";

interface CustomHTMLProps extends React.HTMLProps<HTMLInputElement> {
  startAddon: React.ReactNode;
  endAddon: React.ReactNode;
  startAddOnCallback?: () => void;
  endAddOnCallback?: () => void;
  containerClassName?: string;
  addonWrapperClassName?: string;
  inputClassName?: string;
}
type MergedProps = React.HTMLProps<HTMLElement> & CustomHTMLProps;
const InputWithStartAndEndAddOn: React.FC<MergedProps> = ({
  startAddon,
  endAddon,
  containerClassName,
  startAddOnCallback,
  endAddOnCallback,
  addonWrapperClassName,
  inputClassName,
  ...props
}) => {
  return (
    <div className={clsx(containerClassName)}>
      <div className={clsx("flex mt-2 rounded-md", addonWrapperClassName)}>
        <span
          onClick={() => {
            if (startAddOnCallback) {
              if (!props?.disabled) {
                startAddOnCallback();
              }
            }
          }}
          className={clsx(
            "inline-flex items-center border-gray-300 px-3 border border-r-0 rounded-l-md text-gray-500 sm:text-sm",
            startAddOnCallback && "cursor-pointer",
          )}
        >
          {startAddon}
        </span>
        <input
          {...props}
          className={clsx(
            "block flex-1 border-0 text-center disabled:bg-gray-200 py-1.5 rounded-none ring-1 ring-gray-300  focus:outline-none ring-inset w-2 sm:w-[20px]   text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6",
            inputClassName,
          )}
        />
        <span
          onClick={() => {
            if (endAddOnCallback) {
              if (!props.disabled) {
                endAddOnCallback();
              }
            }
          }}
          className={clsx(
            "inline-flex items-center border-gray-300 px-3 border-r border-t border-b rounded-r-md text-gray-500 sm:text-sm",
            endAddOnCallback && "cursor-pointer",
          )}
        >
          {endAddon}
        </span>
      </div>
    </div>
  );
};

export default InputWithStartAndEndAddOn;
